// Adaptive breathing-pattern selection based on pre-session SUDS.
//
// Rationale: dysregulated patients (high SUDS) struggle to pick the right
// pattern from a menu — that decision burden is itself a friction point.
// Since pre-SUDS is already captured on the previous screen, we use it to
// auto-select a clinically-aligned default. The manual selector remains
// available so the patient can always override.

export function pickPatternForSUDS(suds) {
  // null / undefined → safe default
  const s = typeof suds === "number" ? suds : 4;

  if (s >= 7) {
    return {
      pattern: "4-7-8",
      pacerOn: true,
      label: "High arousal — long exhale to engage the vagal brake",
      bandTone: "high",
    };
  }
  if (s >= 4) {
    return {
      pattern: "4-4-6-2",
      pacerOn: true,
      label: "Moderate distress — steady downshift",
      bandTone: "moderate",
    };
  }
  return {
    pattern: "5-5",
    pacerOn: false,
    label: "Low distress — resonance available if you want it",
    bandTone: "low",
  };
}
